export default __webpack_public_path__ + "static/media/learn.ce161f0e.png";